import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Techdevelopment(props) {
    return (
        <div className="tekrevol_development p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="LMS Software">
                            <h2>LMS Development Services At TekRevol</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <h5 className="strong">As a full-stack software development company covering digital strategies
                            to design to implementation, our LMS development services include:</h5>
                        <div className="bulet_points">
                            <ul>
                                <li>LMS database design and development</li>
                                <li>eLearning resource management and tracking systems</li>
                                <li>Education app and <Link
                                    to="/custom-software-development">software
                                    development</Link></li>
                                <li>LMS code review and testing</li>
                                <li>LMS development consultancy and strategy development</li>
                                <li>Cloud-based LMS development</li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Techdevelopment;